export default "__VITE_ASSET__CUhZs658__"